module.exports = __webpack_public_path__ + "static/artist-development-case-study-c0ef06dcba0045e6f91caf22059b8423.png";